var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLightning = function SvgLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lightning_svg__a",
    d: "M0 0h21.476v33H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(13.262 7.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lightning_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lightning_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.388 19.824h8.897l-3.99 12.673a.386.386 0 0 0 .667.36l15.428-19.05a.387.387 0 0 0-.301-.63H12.19L16.182.502a.386.386 0 0 0-.669-.36L.086 19.194a.387.387 0 0 0 .302.631",
    mask: "url(#lightning_svg__b)"
  })))));
};
export default SvgLightning;